var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.info)?_c('i',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:(_vm.props.info),expression:"props.info",modifiers:{"hover":true}}],staticClass:"fa fa-info"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }